// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1Qv9v","inputDescription":"styles_inputDescription__yaLYW"};